module.exports = __webpack_public_path__ + "static/media/LogoAzul.58ffc56d.png";